import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SaleFormService } from '@app/features/sales/add-sale/steps/sale-form.service';
import { WarrantyActivationMethod } from '@src/app/shared/enums/WarrantyActivationMethod.enum';

@Component({
    selector: 'app-sale-type',
    templateUrl: './sale-type.component.html',
    styleUrl: './sale-type.component.scss',
    host: {
        class: 'app-sale-type'
    },
    standalone: false
})
export class StepSaleTypeComponent implements OnInit {

  @Output() stepSaved = new EventEmitter<void>();

  warrantyActivationMethod = WarrantyActivationMethod;
  selectedDefaultActivation = this.warrantyActivationMethod.SERIAL_NUMBER;

  saleTypeFormGroup: FormGroup = this.fb.group({
    saleType: [this.selectedDefaultActivation, [Validators.required]]
  });

  constructor(
    private fb: FormBuilder,
    private saleFormService: SaleFormService) { }

  ngOnInit() {
    this.initFormStep();
    this.saleTypeFormGroup.controls['saleType'].valueChanges.subscribe(value => {
      this.saleFormService.setStepData('saleType', { saleType: value });
    });

  }

  initFormStep() {
    const stepData = this.saleFormService.getStepData('saleType');
    if (stepData) {
      this.saleTypeFormGroup.patchValue(stepData);
    }
  }

  onSaveStepData() {
    this.saleFormService.setStepData('saleType', this.saleTypeFormGroup.value)
    this.stepSaved.emit();
  }
}
